import { render } from "./ContextMenu.vue?vue&type=template&id=2ede4752"
import script from "./ContextMenu.vue?vue&type=script&lang=js"
export * from "./ContextMenu.vue?vue&type=script&lang=js"
script.render = render

export default script